/**
 * Single source of truth for poster fallbacks
 * - Use a real file served from /public/img
 * - Keep a tiny inline backup only for last-resort (no network)
 */

// 1) File path served by Vite from /public/img/...
//    Put your asset at: public/img/poster-fallback.svg  (or .jpg and change the ext)
export const POSTER_FALLBACK_PATH = "/img/poster-fallback.svg";

// 2) Use the same file path for inline fallback (goat image)
export const POSTER_INLINE_FALLBACK = POSTER_FALLBACK_PATH;

/**
 * (Optional) Generic image fallback for non-video images
 * Keep if other parts of the app use an "image unavailable" placeholder.
 */
export const IMAGE_FALLBACK_DATA_URL =
  "data:image/svg+xml;utf8," +
  encodeURIComponent(
    `<svg xmlns="http://www.w3.org/2000/svg" width="1600" height="900">
      <rect width="100%" height="100%" fill="#ECEEF1"/>
      <rect x="64" y="64" width="1472" height="772" rx="24" fill="#E2E7EE"/>
      <text x="50%" y="50%" dominant-baseline="middle" text-anchor="middle"
            font-family="system-ui,-apple-system,Segoe UI,Roboto" font-size="24" fill="#9AA3AF">
        image unavailable
      </text>
    </svg>`
  );
